/* LLMe — scroll reveal + tiny interactions */
(function () {
  function initReveal() {
    var els = document.querySelectorAll('.llme-reveal');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  // ---- Tabs ----
  function initTabs(scope) {
    var roots = (scope || document).querySelectorAll('.llme-tabs');
    roots.forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var btns = root.querySelectorAll('.llme-tabs__btn');
      var panels = root.querySelectorAll('.llme-tabs__panel');
      var nav = root.querySelector('.llme-tabs__nav');
      btns.forEach(function (btn, i) {
        btn.addEventListener('click', function () {
          btns.forEach(function (b) { b.setAttribute('aria-selected', 'false'); });
          panels.forEach(function (p) { p.classList.remove('is-active'); });
          btn.setAttribute('aria-selected', 'true');
          if (panels[i]) panels[i].classList.add('is-active');
          // przewiń klikniętą zakładkę do widoku (gdy pasek się przewija)
          if (btn.scrollIntoView) btn.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
        });
      });
      // wskaźnik przewijalności (gradient pojawia się gdy są ukryte zakładki)
      if (nav) {
        var sync = function () {
          var overflow = nav.scrollWidth - nav.clientWidth > 4;
          root.classList.toggle('has-overflow', overflow);
          root.classList.toggle('at-end', nav.scrollLeft + nav.clientWidth >= nav.scrollWidth - 4);
          root.classList.toggle('at-start', nav.scrollLeft <= 4);
        };
        nav.addEventListener('scroll', sync, { passive: true });
        window.addEventListener('resize', sync);
        sync();
      }
    });
  }

  function initAll() { initReveal(); initTabs(); }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  // Re-init when sections are added in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    initReveal();
    initTabs(e.target || document);
  });
})();

/* LLMe — Quantity bundle */
(function () {
  function initBundle(scope) {
    (scope || document).querySelectorAll('.llme-bundle').forEach(function (sec) {
      if (sec.dataset.bundleReady) return;
      sec.dataset.bundleReady = '1';
      var grid = sec.querySelector('.llme-bundle__grid');
      var labels = sec.querySelectorAll('.llme-bun');
      var cta = sec.querySelector('[data-add-bundle]');
      var selQInput = sec.querySelector('[data-q-input]');
      var qMinus = sec.querySelector('[data-q-minus]');
      var qPlus = sec.querySelector('[data-q-plus]');
      var tiers = [].slice.call(labels).map(function (l) {
        return { qty: parseInt(l.getAttribute('data-qty') || '1', 10), code: (l.getAttribute('data-code') || '').trim() };
      }).sort(function (a, b) { return a.qty - b.qty; });
      function codeForQty(q) { var c = ''; tiers.forEach(function (t) { if (t.qty <= q) c = t.code; }); return c; }
      function clampQ(q) { q = parseInt(q, 10); if (isNaN(q) || q < 1) q = 1; if (q > 99) q = 99; return q; }
      function highlightQty(q) {
        labels.forEach(function (l) {
          var on = parseInt(l.getAttribute('data-qty'), 10) === q;
          l.classList.toggle('is-active', on);
          var i = l.querySelector('input'); if (i) i.checked = on;
        });
      }
      function setQty(q) { q = clampQ(q); if (selQInput) selQInput.value = q; highlightQty(q); }
      function setActive(lbl) { setQty(parseInt(lbl.getAttribute('data-qty') || '1', 10)); }
      labels.forEach(function (lbl) {
        lbl.addEventListener('click', function () { setActive(lbl); });
      });
      if (qMinus) qMinus.addEventListener('click', function () { setQty((selQInput ? parseInt(selQInput.value, 10) : 1) - 1); });
      if (qPlus) qPlus.addEventListener('click', function () { setQty((selQInput ? parseInt(selQInput.value, 10) : 1) + 1); });
      if (selQInput) {
        selQInput.addEventListener('input', function () { highlightQty(clampQ(selQInput.value)); });
        selQInput.addEventListener('change', function () { setQty(selQInput.value); });
      }
      (function () {
        var checked = sec.querySelector('.llme-bun input:checked');
        var lbl = checked ? checked.closest('.llme-bun') : labels[0];
        setQty(lbl ? parseInt(lbl.getAttribute('data-qty') || '1', 10) : 1);
      })();
      if (cta) cta.addEventListener('click', function () {
        var qty = clampQ(selQInput ? selQInput.value : 1);
        var code = codeForQty(qty);
        cta.classList.add('is-loading');

        function currentVariantId() {
          var form = document.querySelector('product-form-component form') ||
                     document.querySelector('form[action*="/cart/add"]');
          if (form) {
            var idEl = form.querySelector('input[name="id"]:checked') ||
                       form.querySelector('select[name="id"]') ||
                       form.querySelector('input[name="id"]');
            if (idEl && idEl.value) return idEl.value;
          }
          return grid.getAttribute('data-variant');
        }

        function addNow() {
          var vid = currentVariantId();
          if (!vid) { cta.classList.remove('is-loading'); return; }
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: qty }] })
          })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
          .then(function (cart) {
            cta.classList.remove('is-loading');
            var drawer = document.querySelector('cart-drawer-component');
            // proper detail so Horizon re-renders the drawer (event.detail.data must exist)
            var ev = new Event('cart:update', { bubbles: true });
            ev.detail = { resource: cart, sourceId: 'llme-bundle', data: {} };
            document.dispatchEvent(ev);
            if (drawer && typeof drawer.open === 'function') drawer.open();
            else window.location.href = '/cart';
          })
          .catch(function () { cta.classList.remove('is-loading'); window.location.href = '/cart'; });
        }

        // Apply discount code first (sets cart discount cookie), then add
        if (code) {
          fetch('/discount/' + encodeURIComponent(code), { method: 'GET' })
            .then(addNow).catch(addNow);
        } else {
          addNow();
        }
      });
    });
  }
  if (document.readyState !== 'loading') initBundle();
  else document.addEventListener('DOMContentLoaded', initBundle);
  document.addEventListener('shopify:section:load', function (e) { initBundle(e.target || document); });
})();

/* LLMe — Delivery date estimate */
(function () {
  var DNI = ['niedziela','poniedziałek','wtorek','środa','czwartek','piątek','sobota'];
  var MIES = ['stycznia','lutego','marca','kwietnia','maja','czerwca','lipca','sierpnia','września','października','listopada','grudnia'];
  function fill(scope) {
    (scope || document).querySelectorAll('.llme-deliv').forEach(function (el) {
      var out = el.querySelector('[data-llme-deliver]'); if (!out) return;
      var lead = parseInt(el.getAttribute('data-days') || '2', 10);
      var cutoff = parseInt(el.getAttribute('data-cutoff') || '14', 10);
      var d = new Date();
      if (d.getHours() >= cutoff) lead += 1;
      // dolicz tylko dni robocze (pomiń soboty i niedziele)
      var added = 0;
      while (added < lead) {
        d.setDate(d.getDate() + 1);
        var dow = d.getDay();
        if (dow !== 0 && dow !== 6) added++;
      }
      // gdyby mimo to wypadł weekend — przesuń na poniedziałek
      if (d.getDay() === 6) d.setDate(d.getDate() + 2);
      else if (d.getDay() === 0) d.setDate(d.getDate() + 1);
      out.textContent = DNI[d.getDay()] + ', ' + d.getDate() + ' ' + MIES[d.getMonth()];
    });
  }
  if (document.readyState !== 'loading') fill();
  else document.addEventListener('DOMContentLoaded', fill);
  document.addEventListener('shopify:section:load', function (e) { fill(e.target || document); });
})();

/* LLMe — Scroll to top */
(function () {
  var btn = null;
  function init() {
    btn = document.querySelector('[data-llme-scrolltop]');
    if (!btn) return;
    var onScroll = function () {
      if (window.pageYOffset > 400) btn.classList.add('is-visible');
      else btn.classList.remove('is-visible');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    onScroll();
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* LLMe — Mobile carousels (strzałki + kropki + autoplay) */
(function () {
  var SEL = '.llme-features__grid, .llme-benefits__grid, .llme-rev__grid, .llme-blog__grid, .llme-aud__grid';
  var mq = window.matchMedia('(max-width: 749px)');
  var OPTS = window.LLME_OPTS || {};
  var AUTOPLAY = OPTS.autoplay !== false;          // domyślnie wł.
  var SPEED = (parseInt(OPTS.speed, 10) || 5) * 1000;
  var SHOW_ARROWS = OPTS.arrows !== false;
  var SHOW_DOTS = OPTS.dots !== false;

  function step(grid) {
    var first = grid.children[0]; if (!first) return 1;
    var cs = getComputedStyle(grid);
    var gap = parseFloat(cs.columnGap || cs.gap || '12') || 12;
    return first.getBoundingClientRect().width + gap;
  }
  function idxOf(grid) { return Math.round(grid.scrollLeft / step(grid)); }

  function build(grid) {
    if (grid.dataset.car) return;
    var items = Array.prototype.slice.call(grid.children).filter(function (n) { return n.nodeType === 1; });
    if (items.length < 2) return;
    grid.dataset.car = '1';

    function go(i) {
      i = Math.max(0, Math.min(items.length - 1, i));
      grid.scrollTo({ left: i * step(grid), behavior: 'smooth' });
    }

    var prev = null, next = null, dots = null;
    if (SHOW_ARROWS || SHOW_DOTS) {
      var ctrl = document.createElement('div');
      ctrl.className = 'llme-car-ctrl';
      if (SHOW_ARROWS) {
        prev = document.createElement('button');
        prev.type = 'button'; prev.className = 'llme-car-arrow'; prev.setAttribute('aria-label', 'Poprzedni');
        prev.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>';
        prev.addEventListener('click', function () { go(idxOf(grid) - 1); });
        ctrl.appendChild(prev);
      }
      if (SHOW_DOTS) {
        dots = document.createElement('div'); dots.className = 'llme-car-dots';
        items.forEach(function (_, i) {
          var d = document.createElement('button');
          d.type = 'button'; d.className = 'llme-car-dot' + (i === 0 ? ' is-active' : '');
          d.setAttribute('aria-label', 'Slajd ' + (i + 1));
          d.addEventListener('click', function () { go(i); });
          dots.appendChild(d);
        });
        ctrl.appendChild(dots);
      }
      if (SHOW_ARROWS) {
        next = document.createElement('button');
        next.type = 'button'; next.className = 'llme-car-arrow'; next.setAttribute('aria-label', 'Następny');
        next.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>';
        next.addEventListener('click', function () { go(idxOf(grid) + 1); });
        ctrl.appendChild(next);
      }
      grid.parentNode.insertBefore(ctrl, grid.nextSibling);
      grid._carCtrl = ctrl;
    }

    function update() {
      var idx = idxOf(grid);
      if (dots) { var dd = dots.children; for (var i = 0; i < dd.length; i++) dd[i].classList.toggle('is-active', i === idx); }
      if (prev) prev.disabled = idx <= 0;
      if (next) next.disabled = idx >= items.length - 1;
    }
    var t;
    grid.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(update, 60); }, { passive: true });
    update();

    // autoplay (pauza po dotknięciu) — sterowane ustawieniem motywu
    var auto = null;
    if (AUTOPLAY) {
      auto = setInterval(function () {
        var i = idxOf(grid); i = i >= items.length - 1 ? 0 : i + 1; go(i);
      }, SPEED);
    }
    function stop() { if (auto) { clearInterval(auto); auto = null; } }
    grid.addEventListener('pointerdown', stop);
    grid.addEventListener('touchstart', stop, { passive: true });
    grid._carStop = stop;
  }

  function teardown(grid) {
    if (!grid.dataset.car) return;
    delete grid.dataset.car;
    if (grid._carStop) grid._carStop();
    if (grid._carCtrl && grid._carCtrl.parentNode) grid._carCtrl.parentNode.removeChild(grid._carCtrl);
    grid._carCtrl = null;
  }

  function sync(scope) {
    var grids = (scope || document).querySelectorAll(SEL);
    grids.forEach(function (g) { if (mq.matches) build(g); else teardown(g); });
  }

  function init() { sync(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  if (mq.addEventListener) mq.addEventListener('change', function () { sync(); });
  document.addEventListener('shopify:section:load', function (e) { sync(e.target || document); });
})();

/* LLMe — podnieś scroll-top nad sticky add-to-cart */
(function () {
  function init() {
    var btn = document.querySelector('[data-llme-scrolltop]');
    if (!btn) return;
    function adjust() {
      // mierzymy faktyczny widoczny pasek (a nie wrapper custom-elementu)
      var bar = document.querySelector('.sticky-add-to-cart__bar') ||
                document.querySelector('sticky-add-to-cart');
      if (!bar) { btn.style.bottom = ''; return; }
      var r = bar.getBoundingClientRect();
      // pasek "widoczny", gdy ma wysokość i wchodzi w dolną część ekranu
      var visible = r.height > 4 &&
                    r.bottom > window.innerHeight - 4 &&
                    r.top < window.innerHeight - 4;
      btn.style.bottom = visible ? (r.height + 14) + 'px' : '';
    }
    window.addEventListener('scroll', adjust, { passive: true });
    window.addEventListener('resize', adjust);
    setInterval(adjust, 500);
    adjust();
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* LLMe — wymuś autoodtwarzanie wideo w tle hero (mobile) */
(function () {
  function playHeroVideos() {
    document.querySelectorAll('.llme-hero__media video, .llme-hero__video').forEach(function (v) {
      try {
        v.muted = true; v.defaultMuted = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.playsInline = true;
        var p = v.play();
        if (p && p.catch) p.catch(function () {
          // jeśli przeglądarka zablokuje — spróbuj po pierwszym dotknięciu
          var resume = function () { v.play(); document.removeEventListener('touchstart', resume); document.removeEventListener('click', resume); };
          document.addEventListener('touchstart', resume, { once: true });
          document.addEventListener('click', resume, { once: true });
        });
      } catch (e) {}
    });
  }
  if (document.readyState !== 'loading') playHeroVideos();
  else document.addEventListener('DOMContentLoaded', playHeroVideos);
  document.addEventListener('shopify:section:load', playHeroVideos);
})();

/* LLMe — Promo grid: Dodaj do koszyka (AJAX + drawer) */
(function () {
  function addToCart(btn) {
    var id = btn.getAttribute('data-llme-add');
    if (!id || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
    })
    .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
    .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
    .then(function (cart) {
      btn.classList.remove('is-loading');
      var drawer = document.querySelector('cart-drawer-component');
      var ev = new Event('cart:update', { bubbles: true });
      ev.detail = { resource: cart, sourceId: 'llme-promo', data: {} };
      document.dispatchEvent(ev);
      if (drawer && typeof drawer.open === 'function') drawer.open();
      else window.location.href = '/cart';
    })
    .catch(function () { btn.classList.remove('is-loading'); window.location.href = '/cart'; });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-llme-add]') : null;
    if (btn) { e.preventDefault(); addToCart(btn); }
  });
})();

/* LLMe — Formularz zapisu: przełącznik Pierwsza / Kontynuacja */
(function () {
  function initAppt(scope) {
    (scope || document).querySelectorAll('.llme-appt').forEach(function (sec) {
      if (sec.dataset.apptReady) return; sec.dataset.apptReady = '1';
      var tabs = sec.querySelectorAll('[data-appt-mode]');
      var firsts = sec.querySelectorAll('.llme-appt__first');
      var nexts = sec.querySelectorAll('.llme-appt__next');
      var typefield = sec.querySelector('[data-appt-typefield]');
      function setBranch(nodes, on) {
        nodes.forEach(function (n) {
          n.hidden = !on;
          n.querySelectorAll('input, select, textarea').forEach(function (i) { i.disabled = !on; });
        });
      }
      function setMode(m) {
        var isFirst = m === 'first';
        tabs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-appt-mode') === m); });
        setBranch(firsts, isFirst);
        setBranch(nexts, !isFirst);
        if (typefield) typefield.value = isFirst ? 'Pierwsza konsultacja (NFZ)' : 'Konsultacja kontynuacja (NFZ)';
      }
      tabs.forEach(function (t) { t.addEventListener('click', function () { setMode(t.getAttribute('data-appt-mode')); }); });
      setMode('first');
    });
  }
  if (document.readyState !== 'loading') initAppt();
  else document.addEventListener('DOMContentLoaded', initAppt);
  document.addEventListener('shopify:section:load', function (e) { initAppt(e.target || document); });
})();
